export const fullDate = 'MMMM DD, YYYY';